<template>
  <v-table
    class="table-data"
    fixed-header>
    <thead>
      <tr>
        <th v-for="item in headers"
          :key="item" class="text-left">
          {{item}}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in categories"
        :key="item._id">
        <td>{{ item.name }}</td>
        <td>{{ formatTimestamp(item.updated_at) }}</td>
        <td>{{item.terminal.name }}</td>
        <td>
          <v-menu>
            <template v-slot:activator="{ props }">
              <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props"/>
            </template>
            <v-list>
              <v-list-item  title="Editar" link
              @click="editModal(item)"/>
              <v-list-item  title="Eliminar" link
              @click="openDialogDelete(item)"/>
            </v-list>
          </v-menu>
        </td>
      </tr>
    </tbody>
  </v-table>

  <add-edit-categories ref="addEditModal" @refreshList="refresh"/>

  <diaog-two-options
    ref="deleteDialog"
    @okBtn="deleteObj"
    title="Eliminar categoría"
    txtBtn="Sí, Eliminar"
    :txtBold="objSelected?.name || ''"
    txtOne="¿Deseas eliminar "
    txtTwo="? No podrás deshacer la acción."/>

</template>
<script>
import DiaogTwoOptions from '../dialogs/DiaogTwoOptions.vue'
import AddEditCategories from '../forms/AddEditCategories.vue'
import categoriesApi from '@/api/categoriesApi'
import dateTransform from '@/utils/dateTransform'
export default {
  name: 'CommerciaVueCategoriesTable',
  emits: ['refreshList'],
  components: {
    AddEditCategories,
    DiaogTwoOptions
  },
  props: {
    categories: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      objSelected: null,
      headers: ['Categoría', 'Editado', 'POS Asociado', 'Acciones']
    }
  },
  mounted () { },
  methods: {
    editModal (obj) {
      this.$refs.addEditModal.edit(obj)
    },
    openDialogDelete (obj) {
      this.objSelected = obj
      this.$refs.deleteDialog.open()
    },
    async deleteObj () {
      console.log(this.objSelected)
      if (await categoriesApi.delete(this.objSelected)) {
        this.$emit('refreshList')
      } else {
        console.log('Cambio Fallido')
      }
    },
    refresh () { this.$emit('refreshList') },
    formatTimestamp (timestamp) {
      return dateTransform.timestampToFormat(timestamp)
    }
  }
}
</script>
<style scoped>
  @import '@/assets/styles/tables.css';
</style>
